import React from 'react';

const ThankYou = () => {
    return (
        <div style ={{marginLeft:"450px",marginTop:"30px"}}>
            <img src="https://i.pinimg.com/originals/4a/de/9a/4ade9a536cafc673fc92a6fa071b752f.gif" alt=""/>
        </div>
    );
};

export default ThankYou;